// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Ltkt","info":"PatientInfo_info__1uTGh"};